// "Open WhatsApp to read the OTP" — next to every OTP box (sign-in, sign-up,
// forgot password, new device, guest invitation). It opens the chat with the
// number the OTP messages come FROM, so the user lands on the 4-digit code
// instead of hunting for it, then comes back and types it.
//
// Mehfil by Smartify's OTPs are sent through Meta's official WhatsApp API by
// the backend (the metaapi.anuplights.com proxy, template
// otp_verification_code) from this business number. Digits only, with country
// code. Nothing is SENT from here: it only opens a chat.
import { Capacitor } from '@capacitor/core';

export const OTP_WHATSAPP = '918624827530';

const isPhoneBrowser = () => /Android|iPhone|iPad|iPod/i.test(typeof navigator !== 'undefined' ? navigator.userAgent : '');

export const openOtpWhatsApp = () => {
  if (Capacitor.isNativePlatform()) {
    // APK: straight into the installed WhatsApp app, no browser hop.
    window.location.href = `whatsapp://send?phone=${OTP_WHATSAPP}`;
  } else if (isPhoneBrowser()) {
    // Phone browser: wa.me hands over to the WhatsApp app (WhatsApp Web does
    // not work on a phone).
    window.location.href = `https://wa.me/${OTP_WHATSAPP}`;
  } else {
    // Desktop: straight into the conversation on WhatsApp Web.
    window.open(`https://web.whatsapp.com/send?phone=${OTP_WHATSAPP}`, '_blank', 'noopener,noreferrer');
  }
};
